var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavbarCrossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 1.4866C24 1.0857 23.844 0.708638 23.5605 0.425425C22.9936 -0.141808 22.0063 -0.141808 21.4394 0.425425L12 9.8705L2.56054 0.425425C1.99365 -0.141808 1.00634 -0.141808 0.439448 0.425425C0.156031 0.708638 0 1.08571 0 1.4866C0 1.88745 0.156031 2.26452 0.439456 2.54778L9.87891 11.9929L0.439456 21.4379C0.156031 21.7211 0 22.0982 0 22.4991C0 22.9 0.156031 23.277 0.439456 23.5603C1.00635 24.1275 1.99366 24.1275 2.56055 23.5603L12 14.1152L21.4395 23.5603C21.7229 23.8439 22.0994 24 22.5 24C22.9007 24 23.2771 23.8439 23.5605 23.5603C23.844 23.277 24 22.9 24 22.4991C24 22.0982 23.844 21.7211 23.5605 21.4379L14.1211 11.9929L23.5605 2.54778C23.844 2.26452 24 1.88745 24 1.4866Z",
    fill: "#007EA7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbarCrossIcon);
export default __webpack_public_path__ + "static/media/navbar-cross-icon.c16821d97a96b4e4d33be88dfaf576b3.svg";
export { ForwardRef as ReactComponent };